import { render, staticRenderFns } from "./TcInscriptionSuccess.vue?vue&type=template&id=7f04050a&"
import script from "./TcInscriptionSuccess.vue?vue&type=script&lang=js&"
export * from "./TcInscriptionSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f04050a')) {
      api.createRecord('7f04050a', component.options)
    } else {
      api.reload('7f04050a', component.options)
    }
    module.hot.accept("./TcInscriptionSuccess.vue?vue&type=template&id=7f04050a&", function () {
      api.rerender('7f04050a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcInscriptionSuccess.vue"
export default component.exports